import { 
    useState, useEffect, useRef 
}                                   from 'react';
import { 
    useSelector,
    shallowEqual
}                                   from "react-redux";
import { useNavigate }              from 'react-router-dom';
import Textfield                    from 'app/common/uikit/textfield';
import { 
    useInvoiceQuery, 
    useDownloadFile,
}                                   from 'app/services/query';
import SendMail                     from './components/send-mail';

const Invoice = _props => {
    const navigate                  = useNavigate();
    const r 			            = useSelector(state => ({
        accessToken     : state.provider.accessToken,
        invoiceData     : state.provider.invoiceData,
        customer        : state.provider.customer,
        queryData       : state.provider.queryData,
    }), shallowEqual);

    const [ s, setState ]           = useState({
        customerIdentity            : r?.queryData?.customerIdentity || null,
        invoiceNumber               : r?.invoiceData?.earchiveInvoice?.documentId,
        amount                      : r?.invoiceData?.earchiveInvoice?.payableAmount,
        outputType                  : 'Html',
        includeInvoiceBinaryData    : true,
        compressedBinaryData        : false
    });

    const [ modalState, setModalState ] = useState({
        showSendEmail               : false,
        showDownloadMenu            : false,
    })

    const toggleModal = (modal, status) => {
        setModalState(prevState => ({
            ...prevState,
            [modal]: status
        }))
    }
    
    const invoiceQueryHandler       = useInvoiceQuery();
    const downloadFileHandler       = useDownloadFile();

    const menuRef                   = useRef(null)
    const buttonRef                 = useRef(null)

    const goBack = () => {
        navigate('/');
    }

    const updateFormData = (node, value) => {
        setState(prevState => ({
            ...prevState,
            [node]: value
        }))
    }

    const fromBinary = encoded => {
        return decodeURIComponent(atob(encoded).split('').map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    const renderInvoice = () => {
        if (!r?.queryData?.customerIdentity)
            return goBack();
        
        if (r?.invoiceData?.data) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            return <iframe id="invoice-viewer" title="invoice-viewer" srcDoc={ fromBinary(r?.invoiceData?.data) } />;
        }

        return <div className="search-error-wrapper"><div>Üzgünüz ancak böyle bir fatura bulamadık. Lütfen bilgilerinizi kontrol edip yeniden arama yapın.</div></div>;
    }

    const validateCustomerInfo = () => {
        return s.customerIdentity === r.customer.loggedCustomerIdentity;
    }

    const findInvoice = () => {
        if (validateCustomerInfo()) {
            invoiceQueryHandler.mutate({
                accessToken : r.accessToken,
                amount      : s.amount,
                data        : {
                    invoiceNumber           : s.invoiceNumber,
                    outputType              : 'Html',
                    includeInvoiceBinaryData: true,
                    compressedBinaryData    : false,
                },
                callback: () => {
                    toggleModal('showSearchError', true);
                }
            })
        }        
    }

    const printInvoice = () => {
        const iframe = document.getElementById('invoice-viewer');
        iframe.contentWindow.print();
    }

    const renderModal = () => {
        if (modalState.showSendEmail)
            return <SendMail closeModal={ () => toggleModal('showSendEmail', false) } />
    }

    const handleBlur = (e) => {
        e.stopPropagation();

        if (buttonRef.current.contains(e.target) || menuRef.current.contains(e.target)) {
            return;
        }

        toggleModal('showDownloadMenu', false);
    }

    const downloadFile = fileType => {
        downloadFileHandler.mutate({
            accessToken : r.accessToken,
            data        : {
                invoiceNumber           : s.invoiceNumber,
                outputType              : fileType,
                includeInvoiceBinaryData: true,
                compressedBinaryData    : false,
            },
        });

        toggleModal('showDownloadMenu', false);
    }

    useEffect(() => {
        window.addEventListener('click', handleBlur, false);

        if (!r?.queryData?.customerIdentity)
            goBack();

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('click', handleBlur, false);
            }
        }    
        // eslint-disable-next-line react-hooks/exhaustive-deps     
    }, [])

    

    return (
        <div id="invoice-detail-wrapper">
            { renderModal() }
            <div className="invoice-detail-continer">
                <div className="invoice-detail-continer-header">
                    <div className="back-button" onClick={ () => goBack() }>
                        <div className="back"></div>
                        Geri | <b>Fatura Detayı</b>
                    </div>

                    <div className="title">
                        <div className="badge">E-arşiv</div>
                        <b>/ Fatura Önizleme</b>
                    </div>
                    <div className="buttons">
                        {/* <button className="button" disabled={ !r?.invoiceData?.data } onClick={ () => toggleModal('showSendEmail', true) }><div className="icon flat letter"></div>E-posta gönder</button> */}
                        <button className="button" disabled={ !r?.invoiceData?.data } ref={ buttonRef } onClick={ () => toggleModal('showDownloadMenu', true) }><div className="icon flat export"></div>İndir</button>
                        <button className="button" disabled={ !r?.invoiceData?.data } onClick={ () => printInvoice() }><div className="icon flat printer"></div>Yazdır</button>
                        <div className={ `download-submenu${modalState.showDownloadMenu ? ' visible' : ''}` } ref={ menuRef }>
                            <div className="item" onClick={ () => downloadFile('html') }>HTML</div>
                            <div className="item" onClick={ () => downloadFile('ubl') }>UBL</div>
                            <div className="item" onClick={ () => downloadFile('pdf') }>PDF</div>
                        </div>
                    </div>
                </div>
                <div className="invoice-detail-continer-content">
                    <div className="query-form-container">
                        <div className="query-form-container-header">Fatura Sorgulama</div>
                        <div className="query-form-container-content">
                            <div className="col">
                                <Textfield
                                    attrs       = {{
                                        id: 'customerIdentity',
                                        name: 'customerIdentity',
                                        tabIndex: 1,
                                        maxLength: 11,
                                        disabled: true

                                    }}
                                    label       = { 'Satıcı VKN / TCKN' }
                                    onChange    = { value => updateFormData('customerIdentity', value )}
                                    value       = { s.customerIdentity }
                                    type        = { 'number' }
                                    dsabled         
                                    fieldName   = { 'customerIdentity' }
                                    placeholder = { 'Kimlik numarası' }
                                    errors      = { [] }
                                /> 
                            </div>
                            <div className="col">
                                <Textfield
                                    attrs       = {{
                                        id: 'invoiceNumber',
                                        name: 'invoiceNumber',
                                        tabIndex: 2,
                                        maxLength: 16
                                    }}
                                    label       = { 'Fatura Numarası' }
                                    onChange    = { value => updateFormData('invoiceNumber', value )}
                                    value       = { s.invoiceNumber }
                                    fieldName   = { 'invoiceNumber' }
                                    placeholder = { '16 haneli fatura numarası' }
                                    errors      = { [] }
                                />     
                            </div>
                            <div className="col">
                                <Textfield
                                    attrs       = {{
                                        id: 'amount',
                                        name: 'amount',
                                        tabIndex: 3
                                    }}
                                    label       = { 'Ödenecek Tutar' }
                                    onChange    = { value => updateFormData('amount', value )}
                                    value       = { s.amount }
                                    fieldName   = { 'amount' }
                                    type        = { 'number' }
                                    errors      = { [] }
                                />  
                            </div>
                        </div>
                        <div className="query-form-container-footer">
                            <div className="button">Temizle</div>
                            <button className="button colored" disabled={ invoiceQueryHandler.isPending } onClick={ () => findInvoice() }>Fatura Sorgula</button>


                        </div>
                    </div>
                    { 
                        !invoiceQueryHandler.isPending
                            ?   renderInvoice() 
                            :   <div className="loading">Yükleniyor...</div>
                    }
                </div>
            </div>

        </div>
    )
}

export default Invoice